import Api from "@/services/api";
import {
	LOAD_PROTOCOL,
	CREATE_PROTOCOL,
	EDIT_PROTOCOL,
	REMOVE_PROTOCOL,
	REMOVE_PROTOCOLS,
	ADD_ALERT,
} from "@/store/_actiontypes";
import {
	SET_PROTOCOL,
	ADD_PROTOCOL,
	UPDATE_PROTOCOL,
	DELETE_PROTOCOL,
} from "@/store/_mutationtypes";

const state = {
	protocolslist: [],
};

const actions = {
	[LOAD_PROTOCOL]({ commit }) {
		Api.get("/protocols").then((response) => {
			let item = response.data;
			commit(SET_PROTOCOL, item);
		});
	},
	[CREATE_PROTOCOL]({ commit, dispatch }, { item }) {
		return Api.post("/protocols", {
			name: item.name,
			type: item.type,
			jsonConfig: item.jsonConfig,
		}).then((response) => {
			let item = response.data;
			commit(ADD_PROTOCOL, item);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Protocol added successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[EDIT_PROTOCOL]({ commit, dispatch }, { item }) {
		return Api.put(`/protocols/${item.id}`, item).then((response) => {
			let item = response.data;
			commit(UPDATE_PROTOCOL, item);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Protocol updaded successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_PROTOCOL]({ commit, dispatch }, { id }) {
		Api.delete(`/protocols/${id}`).then(() => {
			commit(DELETE_PROTOCOL, id);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Protocol deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_PROTOCOLS]({ commit, dispatch }, { ids }) {
		ids.forEach((id) => {
			Api.delete(`/protocols/${id}`).then(() => {
				commit(DELETE_PROTOCOL, id);
			});
			dispatch(
				`alert/${ADD_ALERT}`,
				{
					message: `Successfully deleted ${ids.length} protocols`,
					color: "success",
				},
				{ root: true }
			);
		});
	},
};

const mutations = {
	[SET_PROTOCOL](state, item) {
		state.protocolslist = item;
	},
	[ADD_PROTOCOL](state, item) {
		state.protocolslist.push(item);
	},
	[UPDATE_PROTOCOL](state, item) {
		let lVar = state.protocolslist.find((h) => h.id == item.id);
		lVar.name = item.name;
		lVar.type = item.type;
		lVar.jsonConfig = item.jsonConfig;
	},
	[DELETE_PROTOCOL](state, id) {
		state.protocolslist = state.protocolslist.filter((h) => h.id != id);
	},
};

export const protocols = {
	namespaced: true,
	state,
	actions,
	mutations,
};
